export default __webpack_public_path__ + "static/media/img-0201-columbia-full-face.b455d2f9.png";